import { connect } from 'react-redux'
import { compose, withHandlers } from 'recompose'
import { planSelector } from '../../../store/selectors/selectors'
import { userSelector } from '../../../store/selectors/baseSelectors'
import { withFirebase } from 'react-redux-firebase'

export default compose(
  connect(
    state => ({
      user: userSelector(state),
      plan: planSelector(state)
    })
  ),
  withFirebase,
  withHandlers({
    logout: props => props.firebase.logout
  })
)
